(function () {
  angular.module('calendarApp').service('FixedHeadingService', FixedHeadingService);

  function FixedHeadingService() {
    this.fixHeading = function () {
      var scrollTop = $(window).scrollTop();

      if (scrollTop >= 180) {
        // $('.heading-not-fixed').css('visibility', 'hidden');
        $('.header-container').addClass('header-container-fixed');
        $('.fixed-header-container').show();
        $('.mobile-next-prev ').css('visibility', 'visible');
      } else {
        // $('.heading-not-fixed').css('visibility', 'visible');
        $('.header-container').removeClass('header-container-fixed');
        $('.fixed-header-container').hide();
        $('.mobile-next-prev ').css('visibility', 'hidden');
      }
    };
  }
})();